import { env } from "../config/env";

export const tx = (hash: string) => `${env.bscscanBase}/tx/${hash}`;
export const addr = (a: string) => `${env.bscscanBase}/address/${a}`;
export const token = (a: string) => `${env.bscscanBase}/token/${a}`;
